// node-modules
import { TimelineMax, TweenMax } from 'gsap/TweenMax';

// other
import selectors from '../animation-selectors';

function getAssets(section, title) {
  return {
    letters: Array.from(section.querySelectorAll(`${title} ${selectors.letter}`)),
  };
}

export default {
  trigger: selectors.title,
  set() {
    const { letters } = getAssets(this.section, selectors.title);
    return TweenMax.set(letters, { autoAlpha: 0 });
  },

  animate() {
    const { letters } = getAssets(this.section, selectors.title);
    const tl = new TimelineMax();
    return tl
      .staggerFromTo(
        letters, selectors.duration,
        // from
        { rotationX: 90 },
        // to
        {
          autoAlpha: 1,
          rotationX: 0,
          clearProps: 'all',
        }, selectors.delay.staggerLetters, selectors.delay.stage_2,
      );
  },
};



// WEBPACK FOOTER //
// ./scripts/animation/elements/title.js